import httpClient from './httpClient';

export const ORDER_ADDRESS_ENDPOINT = '/backoffice/order-addresses';

export const updateOrderAddressAPI = (id, params) => httpClient.put(`${ORDER_ADDRESS_ENDPOINT}/${id}`, params);
